import { Grid, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import { FormProvider, useFormContext } from 'react-hook-form';
import { WsButton, WsColors, WsDrawer } from 'wisestep-base';

import { JobTitleFilter } from '../../../../../components/filters/components';
import CheckboxFilter from '../../../../../components/filters/components/CheckboxFilter';
import { IHotJobsAdvancedFilters } from '../../types/IHotJobsSearch';

interface HotJobsAdvancedFiltersProps {
  open: boolean;
  performSearch: (data: IHotJobsAdvancedFilters) => void;
  filterClose: () => void;
  onReset: () => void;
}

const DrawerFooter = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  position: 'fixed',
  bottom: 1,
  left: 2,
  right: 2,
  justifyContent: 'flex-end',
}));

export const FilterTitle = styled(Typography)(() => ({
  fontsize: '14px',
  fontWeight: 'bold',
  color: WsColors.GenericRichBlack,
}));

const HotJobsAdvancedFilters = ({
  open,
  filterClose,
  performSearch,
  onReset,
}: HotJobsAdvancedFiltersProps) => {
  const methods = useFormContext();
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <WsDrawer
        title="Advanced Filters"
        open={open}
        onClose={() => filterClose()}
        size="medium"
        headerSize="medium"
        style={{ zIndex: '1300' }}
      >
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(performSearch)}
          onReset={() => onReset()}
        >
          <Box pb={7}>
            <List>
              <CheckboxFilter
                name="includeJobsWithoutVisas"
                title="Visa Status"
                label="Include Jobs Without Visas"
              />
              <JobTitleFilter name="jobTitles" placeHolder="Job Title" />
            </List>
          </Box>
          <DrawerFooter>
            <Stack p={1} spacing={2} direction="row">
              <WsButton variant="outlined" size="large" type="reset">
                Reset
              </WsButton>
              <WsButton variant="contained" size="large" type="submit">
                Apply
              </WsButton>
            </Stack>
          </DrawerFooter>
        </Box>
      </WsDrawer>
    </FormProvider>
  );
};
export default HotJobsAdvancedFilters;
